// extracted by mini-css-extract-plugin
export default {"wrap":"BudgetDemoShell_wrap__UfrZ2"};